import React from 'react'
import { ScrollFadeIn, ScrollFadeInStagger } from '../../../components/ScrollFadeIn';
import { CalendarIcon, CheckIcon } from '@heroicons/react/outline';
import { MdOutlineChangeCircle } from 'react-icons/md';
import Container from '../components/Container';
import GetStartedButton from '../components/GetStartedButton';

const Pricing = () => {



    return (
        <Container id="pricing">
            <ScrollFadeIn className="max-w-7xl">
                <div className="relative px-5 sm:px-10 text-gray-800 rounded-t-md">
                    <div className="flex items-center justify-center space-x-6">
                        <div className="bg-gray-800 w-full h-px"></div>
                        <ScrollFadeIn>
                            <h2 className="times text-gray-800 font-[200] text-center text-2xl sm:text-3xl lg:text-4xl tracking-wide min-w-max">
                                OUR PRICE
                            </h2>
                        </ScrollFadeIn>
                        <div className="bg-gray-800 w-full h-px"></div>
                    </div>

                    <div className="flex flex-row items-center justify-center space-x-6 sm:space-x-20 lg:space-x-32 py-10">
                        <ScrollFadeIn className="flex flex-col  sm:flex-row items-center sm:space-x-3">
                                <CalendarIcon className="hidden sm:flex h-10 w-10 lg:h-16 lg:w-16 ml-2" />
                                <div className="flex items-start justify-start">
                                    <h3 className="text-5xl sm:text-5xl lg:text-7xl h-16 font-bold font-sans tracking-wide">$</h3>
                                    <div>
                                        <h3 className="text-5xl sm:text-5xl lg:text-7xl h-16 font-bold font-sans tracking-wide">499</h3>
                                        <p className="font-thin w-max lg:mt-3 sm:text-sm lg:text-base text-secondary-500 times">FIRST MONTH</p>
                                    </div>
                                </div>
                        </ScrollFadeIn>
                        <ScrollFadeIn className="bg-secondary-500 w-px h-36 mx-auto">
                        </ScrollFadeIn>
                        <ScrollFadeIn className="flex items-center sm:space-x-3">
                                <MdOutlineChangeCircle className="hidden sm:flex h-10 w-10 lg:h-16 lg:w-16" />
                                <div className="flex items-start justify-start">
                                    <h3 className="text-5xl sm:text-5xl lg:text-7xl h-16 font-bold font-sans tracking-wide">$</h3>
                                    <div>
                                        <h3 className="text-5xl sm:text-5xl lg:text-7xl h-16 font-bold font-sans tracking-wide">189</h3>
                                        <p className="font-thin w-max lg:mt-3 sm:text-sm lg:text-base text-secondary-500 times">PER MONTH</p>
                                    </div>
                                </div>
                        </ScrollFadeIn>
                    </div>
                </div>
                <div className="flex w-full mx-auto justify-evenly sm:py-8 px-5 sm:px-10">
                    <div className="space-y-8">
                        <ScrollFadeIn>
                            <h2 className="times text-gray-800 font-[200] text-2xl sm:text-3xl lg:text-4xl tracking-wide max-w-xl">
                                Ongoing financial guidance for all of life's adventures:
                            </h2>
                        </ScrollFadeIn>
                        <ScrollFadeInStagger className="text-base list-inside sm:text-2xl lato text-gray-600 space-y-1">
                            <ScrollFadeIn className="flex space-x-2 items-center">
                                <CheckIcon className="text-secondary-500 h-6 w-6 flex-shrink-0" />
                                <span>Dedicated advisor relationship</span>
                            </ScrollFadeIn>
                            <ScrollFadeIn className="flex space-x-2 items-center">
                                <CheckIcon className="text-secondary-500 h-6 w-6 flex-shrink-0" />
                                <span>No account minimums</span>
                            </ScrollFadeIn>
                            <ScrollFadeIn className="flex space-x-2 items-center">
                                <CheckIcon className="text-secondary-500 h-6 w-6 flex-shrink-0" />
                                <span>Full scope of financial guidance</span>
                            </ScrollFadeIn>
                        </ScrollFadeInStagger>
                        <ScrollFadeIn>
                            <GetStartedButton id='home-page-pricing' />
                        </ScrollFadeIn>
                    </div>
                    <ScrollFadeInStagger className="-space-y-10 -mt-20 hidden sm:inline-block z-20">
                        <ScrollFadeIn>
                            <img
                                className="aspect-[3/2] rounded-2xl object-cover w-64 h-72 ml-20"
                                src="https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1658158850/Abundo%20Wealth%20Assets/public-site/home-page/couples_rptnvi.jpg"
                                alt="Happy couple embracing affectionately outdoors in field of yellow flowers, with man in denim jacket and woman in gray top, both with eyes closed and looking content in the natural landscape."
                            />
                        </ScrollFadeIn>
                        <ScrollFadeIn>
                            <img
                                className="aspect-[3/2] rounded-2xl object-cover w-64 h-72"
                                src="https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1658175358/Abundo%20Wealth%20Assets/pages/public-home/individuals_yypbq8_yyknuv.webp"
                                alt="A smiling young woman with long dark hair is looking up at the sky, with palm trees visible in the background. She appears joyful and carefree, wearing a patterned top or dress."
                            />
                        </ScrollFadeIn>
                    </ScrollFadeInStagger>
                </div>
            </ScrollFadeIn>
        </Container>
    )
}

export default Pricing
